// Imports
import { useStateValue } from 'src/modules/_global/jsx/store';
import { ReactProgressItem } from 'src/modules/ReactProgressItem/jsx/component.jsx';

// The Progression Navigation component shown on the left of the Page

export const ReactProgress = () => {

    const [{ globalText, userData, componentsData, questionSectionData } , dispatch] = useStateValue();

    // Returns an array of react components of List Items for the Progress Component
    const returnListItems = () => {

        var rapidAssessmentItems = [];
        var detailedAssessmentItems = [];

        var navigationList = [];

        // sort the items into the assessment types
       componentsData.forEach(item => {
            if (item.pageType === "assessment"){
                var navItem = null;// = buildAccordion(item);
               // navigationList.push(navItem);
                // console.log(item.assessmentType)
                if (item.assessmentType === "rapid"){
                   
                    //concatinate the list it child rapid assessment items                   
                    if(typeof(item.children) !== "undefined"){
                        rapidAssessmentItems = buildArrayOfProgressItems(item.children);
                        navItem = buildAssessment(item,rapidAssessmentItems);
                    }
                    

                    
                } else if (item.assessmentType === "detailed"){
                    if(typeof(item.children) !== "undefined"){
                        detailedAssessmentItems = buildArrayOfProgressItems(item.children);
                        navItem = buildAssessment(item,detailedAssessmentItems);
                    }
                }

                if(navItem !== null){
                    navigationList.push(navItem);
                }
                

            //buildArrayOfProgressItems
            } else {
                var navItem = buildIndidualProgressItem(item);
                navigationList.push(navItem);
            }
        });        


        return navigationList;
    }

    const buildAssessment = (item, children) => {
        return <ReactProgressItem assetID={item.assetID} navName={item.navName} key={item.assetID} isAssessment={true} children={children}/>;
    }

    const buildStandalonePage = (item) => {
        return <ReactProgressItem assetID={item.assetID} navName={item.navName} key={item.assetID} isAssessment={false} isLink={true} />;
    }
    
    const buildIndidualProgressItem = (item) => {
        return <ReactProgressItem assetID={item.assetID} navName={item.navName} key={item.assetID} isAssessment={false}/>;
    }    

    const buildArrayOfProgressItems = (array) => {

        


        return array.map( (item) => { 
            return <ReactProgressItem assetID={item.assetID} navName={item.navName} key={item.assetID} isAssessment={false} pageType={item.pageType}/>
        } );
    }
/*
    const buildArrayOfDetailedAssessmentProgressItems = (array) =>{
        //filter out the items that have 100% complete from rapid assessment

        var filteredArray = array.filter((item) => {
            if(item.pageType === "questionSection"){
                return getUserResultsOfRapidQuestionSection(item.linkedSection) !== 100;
            }

           // console.log("whaaat",item)
            //
            return true;
        })

        return filteredArray.map( (item) => { 
            return <ReactProgressItem assetID={item.assetID} navName={item.navName} key={item.assetID} isAssessment={false} pageType={item.pageType}/>
        } );
    }



    // Get 
    const getRapidQsectionFromAssetID = (rQsectionAssetID) => {
        //filter out all but the rapid sections
        let rapidQsections = Object.values(questionSectionData).filter(
            (item) => {
                return item.assessmentType == "rapid";
            }
        )
        //find the rapid section by assetId from the passed parameter
        let rapidSection = rapidQsections.find((item) =>{
            return item.assetID == rQsectionAssetID;
        })

        return rapidSection;
    }

    // Get percentage score for the linked Rapid Assessment section
    const getUserResultsOfRapidQuestionSection = (rQsectionAssetID) => {
        let rapidQsection = getRapidQsectionFromAssetID(rQsectionAssetID);
        
        let sectionQuestions = rapidQsection.children;       
        let noOfQuestions = sectionQuestions.length;
        let totalScore = 0;
        sectionQuestions.forEach(question => {
            let rQassetID = question.assetID;
            let score = userData.questionResponses[rQassetID];

            if (score === 0) {
                totalScore++;
            } else if (score === 3) {
                noOfQuestions--;
            }
        });

        let percentage = totalScore / noOfQuestions * 100;
       // console.log("totalScore for section:",rapidQsection.navName ,totalScore);
        //console.log("percentage score for section:",rapidQsection.navName ,percentage);

        return percentage;
    }

*/





    

    //group the items into Assessment type - none, rapid and detailed
    const groupListItems = () => {
        componentsData.forEach(item => {
           // if(item.assessmentType)
        });
    }
    
    return (
        <div className="br-app-progression-nav__wrapper">
            <div className="br-app-progression-nav__title">
                <h2 className="br-app-progression-nav__title__text">
                    {globalText.appName}
                </h2>
            </div>
            <div className="br-app-progression-nav__links">
                <ul className="br-app-progression-nav__links__list">
                    { returnListItems() }        
                </ul>
            </div>
        </div>
    );    
};
